import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import clsx from 'clsx';

import { useFeatures } from '@atc/features';
import { formatNumber } from '@atc/string-fns';

import { SubHeading } from 'reaxl';

import srpResultsDuck from '@/ducks/srp/srpResultsDuck.js';

import FilterSortDropdownContainer from './FilterSortDropdownContainer';
import MyWalletIconButton from './MyWalletIconButton';
import SRPJumpLink from './SRPJumpLink';

function SearchResultsCountAndSortContainer() {
    const resultCount = useSelector(srpResultsDuck.selectors.getResultsCount);

    const {
        srp_jump_link: [enableSrpJumpLink],
        my_wallet: [
            enableMyWallet,
            { show_wallet_srp_top_actions: showWalletSrpTopActions },
        ],
        remove_payments_toggle: [removePaymentsToggle],
    } = useFeatures(['srp_jump_link', 'remove_payments_toggle', 'my_wallet']);

    const showWallet = enableMyWallet && showWalletSrpTopActions && !removePaymentsToggle;
    return (
        <div
            className="display-flex margin-bottom-3 align-items-center"
            data-cmp="cntnr-results-sort"
        >
            <SubHeading
                componentClass="h2"
                className="margin-top-2 margin-top-sm-5"
                size={300}
                data-cmp="resultsCount"
                aria-live="assertive"
                aria-atomic="true"
                id="results-count"
                style={{ scrollMargin: '30px' }}
            >
                {formatNumber({ value: resultCount }) + ' Matches '}
                {enableSrpJumpLink && <SRPJumpLink />}
            </SubHeading>

            <div
                className={clsx(
                    'display-flex margin-top-2 margin-left-auto',
                    { 'align-items-center': showWallet },
                )}
            >
                {showWallet && (<div className="margin-right-4"><MyWalletIconButton /></div>)}
                <FilterSortDropdownContainer />
            </div>
        </div>
    );
}

export default memo(SearchResultsCountAndSortContainer);
